import { useMemo } from "react";

import { HotelClinicArrivalCommonProps } from "@/constants/hotelClinicArrivalSections";

import TasksTable from "../components/tasksTable";
import { HotelClinicTaskResolved } from "../types";

export function ClinicArrivalTasksSection({ data, loading = false, ...section }: HotelClinicArrivalCommonProps) {
    const allRows = useMemo((): HotelClinicTaskResolved[] => data.tasks, [data]);
    return (
        <div className="flex min-h-[200px] min-w-0 flex-1 flex-col overflow-hidden">
            <TasksTable rows={allRows} allRows={allRows} loading={loading} {...section} />
        </div>
    );
}
